import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { CreateLdapUserResponse } from 'shared';

interface CompleteStepProps {
  result: CreateLdapUserResponse;
  onDone: () => void;
}

export const CompleteStep: React.FC<CompleteStepProps> = ({ result, onDone }) => {
  const [copied, setCopied] = useState(false);

  const copyPassword = async () => {
    if (!result.generatedPassword) return;
    await navigator.clipboard.writeText(result.generatedPassword);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div data-component="ldap-wizard-complete" className="flex flex-col gap-4 items-center py-4">
      <i className="pi pi-check-circle text-green-500" style={{ fontSize: '3rem' }} />
      <div className="text-center">
        <h3 className="text-lg font-semibold">
          User <span className="font-mono">{result.user.uid}</span> created
        </h3>
        <p className="text-sm text-gray-500">
          {result.user.cn} · {result.user.mail}
          {result.user.groups.length > 0 && <> · {result.user.groups.join(', ')}</>}
        </p>
      </div>

      {result.generatedPassword && (
        <div className="w-full flex flex-col gap-2">
          <Message
            severity="warn"
            text="This password is shown only once - copy it now and share it with the user."
            className="w-full"
          />
          <div className="flex items-center gap-2 border rounded-lg p-3 bg-gray-50">
            <code className="font-mono text-lg flex-1 break-all select-all">
              {result.generatedPassword}
            </code>
            <Button
              icon={copied ? 'pi pi-check' : 'pi pi-copy'}
              label={copied ? 'Copied' : 'Copy'}
              className={copied ? 'p-button-success' : 'p-button-outlined'}
              onClick={copyPassword}
            />
          </div>
          <small className="text-gray-500 text-center">
            The user can change it anytime at pass.linienriss.org
          </small>
        </div>
      )}

      <Button label="Done" icon="pi pi-check" onClick={onDone} className="mt-2" />
    </div>
  );
};
